import { Injectable } from '@angular/core';
import { AccountType } from 'src/app/enums/user-role';
import { FbosService } from 'src/app/services/fbos.service';
import { SnackBarService } from 'src/app/ui-services/snackbar/snackBar.service';
import { DeleteConfirmationComponent, DeleteConfirmationData } from 'src/app/shared/components/delete-confirmation/delete-confirmation.component';
import { ProceedConfirmationComponent } from 'src/app/shared/components/proceed-confirmation/proceed-confirmation.component';
import { AppDialogWrapperService } from 'src/app/ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

@Injectable({
    providedIn: 'root',
})
export class FboUiService {
    constructor(
        private snackBarService: SnackBarService,
        private appDialogWrapperService: AppDialogWrapperService,
        private fbosService: FbosService
    ) {}
    deactivateAccount(record) {
        const dialogWrapper = this.appDialogWrapperService.open<boolean>({
            title: 'Deactivate FBO',
            component: ProceedConfirmationComponent,
            data: {
                buttonText: 'Confirm',
                title: 'Deactivate FBO',
                description:
                    'You are about to deactivate and set the FBO to Freemium. Please Confirm that you want to proceed.',
            },
            width: '450px'
        });

        dialogWrapper.afterClosed().subscribe((result: boolean) => {
            if (!result) {
                return;
            }
            record.accountType = AccountType.Freemium;
            this.fbosService.deactivate(record).subscribe(
                () => (result) => {
                    this.snackBarService.showSuccessSnackBar(
                        record.fbo + ' deactivated'
                    );
                },
                (error) => {
                    record.accountType = AccountType.Premium;
                    console.log(error);
                    this.snackBarService.showErrorSnackBar(
                        record.fbo +
                            ' was not deactivated, contact support for more information'
                    );
                }
            );
        });
    }
    activateAccount(record) {
        const dialogWrapper = this.appDialogWrapperService.open<boolean>({
            title: 'Activate FBO',
            component: ProceedConfirmationComponent,
            data: {
                buttonText: 'Confirm',
                title: 'Activate FBO',
                description:
                    'You are about to activate and set the FBO to Premium. Please Confirm that you want to proceed.',
            },
            width: '450px'
        });

        dialogWrapper.afterClosed().subscribe((result: boolean) => {
            if (!result) {
                return;
            }
            record.accountType = AccountType.Premium;
            this.fbosService.activate(record).subscribe(
                () => (result) => {
                    this.snackBarService.showSuccessSnackBar(
                        record.fbo + ' activated'
                    );
                },
                (error) => {
                    record.accountType = AccountType.Freemium;
                    console.log(error);
                    this.snackBarService.showErrorSnackBar(
                        record.fbo +
                            ' was not activated, contact support for more information'
                    );
                }
            );
        });
    }
    public deleteRecord(record) {
        const dialogWrapper = this.appDialogWrapperService.open<DeleteConfirmationData>({
            title: 'Delete FBO',
            component: DeleteConfirmationComponent,
            data: { description: 'FBO', item: record, includeThis: true } as DeleteConfirmationData,
            width: '450px',
            hideHeader: true
        });

        dialogWrapper.afterClosed().subscribe((result: DeleteConfirmationData) => {
            if (!result) {
                return;
            }
            this.fbosService.remove(record).subscribe(
              () => (result) => {
                    this.snackBarService.showErrorSnackBar(
                        record.fbo + ' is deleted'
                    );
                },
                (error) => {
                    console.log(error);
                    this.snackBarService.showErrorSnackBar(
                        record.fbo +
                            ' was not deleted, contact support for more information'
                    );
                }
            );
        });
    }
}
